import $ from 'jquery';

$(function() {
    // Floating CTA
    $('.block-floating-cta').each(function (index, element) {
        $('.block-floating-trigger', element).on('click', function () {
            $(this).toggleClass('active');
            $('.block-floating-bubble', element).toggleClass('open');
        });
        $('.block-floating-close', element).on('click', function () {
            $('.block-floating-trigger', element).toggleClass('active');
            $('.block-floating-bubble', element).removeClass('open');
        });
    });
});
